import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IHubOverviewMessageState,
  IShowOverviewMessageBarParams,
} from '../../interfaces/MessageBar';

const initialState: IHubOverviewMessageState = {
  show: false,
  intent: 'info',
  message: '',
};

const hubOverviewMessageBarSlice = createSlice({
  name: 'hubOverviewMessageBar',
  initialState,
  reducers: {
    showOverviewMessageBar: (state, action: PayloadAction<IShowOverviewMessageBarParams>) => {
      state.show = true;
      state.intent = action.payload.intent;
      state.message = action.payload.message;
    },
    hideOverviewMessageBar: (state) => {
      state.show = false;
      state.intent = 'info';
      state.message = '';
    },
  },
});

export const { showOverviewMessageBar, hideOverviewMessageBar } =
  hubOverviewMessageBarSlice.actions;
export default hubOverviewMessageBarSlice.reducer;
